import {Card, ListItemText, ListSubheader, styled} from '@mui/material';

const StyledCard = styled(Card)`
	margin-top: -16px;
	border-radius: 0px;
	padding: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		border-radius: 16px;
		margin-top: initial;
		margin-left: 8px;
	}
`;

const StyledListSubheader = styled(ListSubheader)`
	font-weight: 600;
	padding-inline: 0;
	color: ${({theme}) => theme.palette.text.primary};
`;

const StyledListItemText = styled(ListItemText)`
	& .MuiListItemText-primary {
		font-size: 1rem;
		color: ${({theme}) => theme.palette.text.primary};
	}

	& .MuiListItemText-secondary {
		font-size: 0.875rem;
		color: ${({theme}) => theme.palette.text.secondary};
	}
`;

export {StyledCard, StyledListSubheader, StyledListItemText};
